export enum ServiceType {
  WORKER = "worker",
  APPS = "apps",
}
